import * as React from 'react';
import { bindHandler } from '../../../utils';
import { useObserver } from '../../../utils/ObserverHooks';
export default function Toggle(props) {
    const toggle = useObserver(props.data);
    const { onItemSelected, disabled, checked, primaryText, secondaryText } = toggle;
    const onSelected = bindHandler(props.handleSelected, null, onItemSelected);
    const onToggleOn = (event) => {
        var _a;
        event.stopPropagation();
        (_a = event.detail) === null || _a === void 0 ? void 0 : _a.stopPropagation();
        onSelected();
    };
    return (React.createElement("music-toggle", { disabled: disabled, checked: checked, ontoggleOn: onToggleOn, "primary-text": primaryText, "secondary-text": secondaryText }));
}
